import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const OrderEdit = () => {
  const initialOrder = {
    order_id: "",
    order_no: "",
    user_id: "",
    product_id: "",
    product_name: "",
    qty: "",
    total: "",
    order_status: "",
    payment_status: "",
    payment_mode: "",
    order_date: "",
    contact_id: "",
    customer_name: "",
    phone: "",
    contact_address: "",
  };

  const [OrderEditUser, setOrderEditUser] = useState(initialOrder);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrderData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_new_order",
          {
            order_id: id,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        
        if (response.data?.status && response.data.data?.length > 0) {
          setOrderEditUser(response.data.data[0]);
        } else {
          toast.error("Order not found");
        }
      } catch (error) {
        console.error("Error fetching Order data!", error);
        toast.error("Failed to fetch order details");
      }
    };

    fetchOrderData();
  }, [id]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setOrderEditUser({ ...OrderEditUser, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const payload = {
      order_id: id,
      order_no: OrderEditUser.order_no,
      user_id: OrderEditUser.user_id,
      product_id: OrderEditUser.product_id,
      product_name: OrderEditUser.product_name,
      qty: OrderEditUser.qty,
      total: OrderEditUser.total,
      order_status: OrderEditUser.order_status,
      payment_status: OrderEditUser.payment_status,
      payment_mode: OrderEditUser.payment_mode,
      order_date: OrderEditUser.order_date,
      contact_id: OrderEditUser.contact_id,
      customer_name: OrderEditUser.customer_name,
      phone: OrderEditUser.phone,
      contact_address: OrderEditUser.contact_address,
    };

    try {
      const response = await axios.post(
        `https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_new_order`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.status === true || response.data?.status === "true") {
        toast.success(response.data.message || "Order updated successfully");
        navigate("/Order-list");
      } else {
        toast.error(response.data.message || "Failed to update Order");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("An error occurred while updating the order");
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Order Edit</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Order</a>
                </li>
                <li className="breadcrumb-item active">Order Edit</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-xl-9 col-lg-8 ">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">General Information</h4>
              </div>
              <div className="card-body">
                <form onSubmit={submitForm}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="order-no" className="form-label">
                          Order Number
                        </label>
                        <input
                          type="text"
                          id="order-no"
                          className="form-control"
                          placeholder="Order Number"
                          name="order_no"
                          value={OrderEditUser.order_no}
                          onChange={changeHandler}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="product-name" className="form-label">
                          Product Name
                        </label>
                        <input
                          type="text"
                          id="product-name"
                          className="form-control"
                          placeholder="Product Name"
                          name="product_name"
                          value={OrderEditUser.product_name}
                          onChange={changeHandler}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="customer-name" className="form-label">
                          Customer Name
                        </label>
                        <input
                          type="text"
                          id="customer-name"
                          className="form-control"
                          placeholder="Customer Name"
                          name="customer_name"
                          value={OrderEditUser.customer_name}
                          onChange={changeHandler}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="phone" className="form-label">
                          Phone
                        </label>
                        <input
                          type="text"
                          id="phone"
                          className="form-control"
                          placeholder="Phone Number"
                          name="phone"
                          value={OrderEditUser.phone}
                          onChange={changeHandler}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="qty" className="form-label">
                          Quantity
                        </label>
                        <input
                          type="number"
                          id="qty"
                          className="form-control"
                          placeholder="Quantity"
                          name="qty"
                          value={OrderEditUser.qty}
                          onChange={changeHandler}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="total" className="form-label">
                          Total Amount
                        </label>
                        <input
                          type="number"
                          id="total"
                          className="form-control"
                          placeholder="Total Amount"
                          name="total"
                          value={OrderEditUser.total}
                          onChange={changeHandler}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="order-status" className="form-label">
                          Order Status
                        </label>
                        <select
                          className="form-control"
                          id="order-status"
                          name="order_status"
                          value={OrderEditUser.order_status}
                          onChange={changeHandler}
                          required
                        >
                          <option value="">Select Status</option>
                          <option value="Pending">Pending</option>
                          <option value="Processing">Processing</option>
                          <option value="Shipped">Shipped</option>
                          <option value="Delivered">Delivered</option>
                          <option value="Cancelled">Cancelled</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="payment-status" className="form-label">
                          Payment Status
                        </label>
                        <select
                          className="form-control"
                          id="payment-status"
                          name="payment_status"
                          value={OrderEditUser.payment_status}
                          onChange={changeHandler}
                          required
                        >
                          <option value="">Select Payment Status</option>
                          <option value="Pending">Pending</option>
                          <option value="Completed">Completed</option>
                          <option value="Failed">Failed</option>
                          <option value="Refunded">Refunded</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="payment-mode" className="form-label">
                          Payment Mode
                        </label>
                        <select
                          className="form-control"
                          id="payment-mode"
                          name="payment_mode"
                          value={OrderEditUser.payment_mode}
                          onChange={changeHandler}
                          required
                        >
                          <option value="">Select Payment Mode</option>
                          <option value="Card">Card</option>
                          <option value="Cash">Cash</option>
                          <option value="UPI">UPI</option>
                          <option value="Net Banking">Net Banking</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="order-date" className="form-label">
                          Order Date
                        </label>
                        <input
                          type="date"
                          id="order-date"
                          className="form-control"
                          name="order_date"
                          value={OrderEditUser.order_date}
                          onChange={changeHandler}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label htmlFor="contact-address" className="form-label">
                          Contact Address
                        </label>
                        <textarea
                          id="contact-address"
                          className="form-control"
                          placeholder="Contact Address"
                          name="contact_address"
                          value={OrderEditUser.contact_address}
                          onChange={changeHandler}
                          rows="3"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="p-3 bg-light mb-3 rounded">
                    <div className="row justify-content-end g-2">
                      <div className="col-lg-2">
                        <button
                          type="submit"
                          className="btn btn-outline-secondary w-100"
                        >
                          Save Change
                        </button>
                      </div>
                      <div className="col-lg-2">
                        <Link
                          to="/Order-list"
                          className="btn btn-primary w-100"
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default OrderEdit;